import axios from "axios"
export function getAdvertiserDetails(token, advertiserId) {
    return axios.get(process.env.REACT_APP_API_URL + `/getAdvertiserDetails?advertiserId=${advertiserId}`, {
        headers: {
            'Authorization': `${token}`
        }
    });
}